export default __webpack_public_path__ + "static/media/minions.5e42cd9a.jpg";